

const API_URL = process.env.REACT_APP_API_URL;
export const signInUser = async (email, password) => {
  try {
    const response = await fetch(`${API_URL}/login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include", // ✅ 쿠키 포함 (Refresh Token 저장을 위해 필요!)
      body: JSON.stringify({ email, password }),
    });

    const data = await response.json();
    if (response.ok && data.accessToken) {
      sessionStorage.setItem("accessToken", data.accessToken);

      console.log("✅ 로그인 성공!");
      return { success: true, accessToken: data.accessToken }; // ✅ 반환 추가
    } else {

      return { success: false, error: data.detail || "로그인 실패" }; // ✅ 실패 시 오류 반환
      
    }
  } catch (error) {
    console.error("⛔ 로그인 실패:", error);

    return { success: false, error: "서버 오류" }; // ✅ 예외 처리 후 반환

  }
};
